import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { assetPurchaseOrderStatusOptions } from '~/models/modules/Asset/Orders/assetPurchaseOrderStatusOptions';
import { GridFieldSummary } from '~/models/modules/gridField';

@Component({
    selector: 'asap-popup-selector',
    templateUrl: './popup-selector.component.html',
    styleUrls: ['./popup-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupSelectorComponent implements OnInit {

  _showPopupSelector:boolean = false;
  @Input()
  get showPopupSelector(): boolean{
    return this._showPopupSelector;
  }
  set showPopupSelector(input: boolean){
    this._showPopupSelector = input;
  }
  _gridFields:GridFieldSummary[] = [];
  @Input()
  get gridFields():GridFieldSummary[]{
    return this._gridFields;
  }
  set gridFields(input: GridFieldSummary[]){
    if(input){
      input = input.filter((f) => !this.execludedFields.includes(f.field));
      this._gridFields = [...input];
    }
  }
  @Input() singleSelection:boolean = true;
  @Input() title:string;
  @Input() _entity:string;
  @Input() _pageName:string;
  @Input() _resolver: (params?: any, model?: any) => Observable<any[] | DataWithPagingMetadata<any>>;
  @Input() _assetPurchaseOrderStatusValue : assetPurchaseOrderStatusOptions;
  @Input() HideNotesFields:boolean = true;
  @Input() execludedFields:string[] = [];
  @Output() CloseWindowHandler:EventEmitter<boolean> = new EventEmitter();
  @Output() ReturnSelectedItemHandler:EventEmitter<any> = new EventEmitter();
  @Output() RowSelectionChanges:EventEmitter<any> = new EventEmitter();
  @Output() RowObjectSelectionChanges:EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  onCloseWindow(close: boolean){
    this.CloseWindowHandler.emit(close);
  }
  onReturnSelectedItem(item:any){
    this.ReturnSelectedItemHandler.emit(item);
  }
  onRowSelectionChanges(item:any){
    this.RowSelectionChanges.emit(item);
  }
  onRowObjectSelectionChanges(item:any){
    this.RowObjectSelectionChanges.emit(item);
  }

}
